import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { FlowLine } from './FlowLine';
export function TomosSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-270" data-mp="1p4lg6ybtv5mo">
      <div className="mx-auto max-w-6xl" data-id="element-271" data-mp="1u2n9sd6vqnce">
        <div className="mx-auto max-w-3xl text-center" data-id="element-272" data-mp="1u1lq5kbsssj2">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-273" data-mp="xce327vj6bd1">
            Les 6 volumes du système
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-274" data-mp="11er5onezdt5l">
            Chaque volume répond à une partie différente de votre enseignement
          </h2>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-275" data-mp="1bd6x6rhx74fm">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-xl border border-brand-line bg-white p-6 shadow-card sm:p-8" data-id="element-276" data-mp="2hr6aa6jotvtx" data-mpi={index}>
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-gold" data-id="element-277" data-mp="2cned35harzm3">
                {volume.number}
              </p>
              <h3 className="mt-2 text-2xl font-semibold leading-snug text-brand-ink" data-id="element-278" data-mp="27r7ejxr8dqe6">
                {volume.title}
              </h3>
              <p className="mt-3 border-l-2 border-brand-rose pl-4 text-sm font-medium leading-6 text-brand-deep" data-id="element-279" data-mp="1yw9hqfkypthk">
                {volume.subtitle}
              </p>
              <div className="mt-6" data-id="element-280" data-mp="1tw52esvsj4sx">
                <h4 className="text-sm font-semibold text-brand-ink" data-id="element-281" data-mp="1oz4u0bbgxpyn">
                  Que résout ce volume dans votre enseignement ?
                </h4>
                {volume.problem.map(paragraph => <p key={paragraph} className="mt-2 text-sm leading-6 text-brand-muted" data-id="element-282" data-mp="1ab4vemyput7h">
                    {paragraph}
                  </p>)}
              </div>
              {volume.extraList && <div className="mt-5" data-id="element-283" data-mp="15cjt8hzwlzge">
                  <p className="text-sm font-medium text-brand-ink" data-id="element-284" data-mp="15dd15malmv04">
                    {volume.extraList.label}
                  </p>
                  <ul className="mt-2 space-y-1.5" data-id="element-285" data-mp="1y1qxlxm1hj9k">
                    {volume.extraList.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-brand-muted" data-id="element-286" data-mp="1kavn6gvw6u3v">
                        <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-287" data-mp="1o9kz051a83le" />
                        {item}
                      </li>)}
                  </ul>
                </div>}
              <div className="mt-6" data-id="element-288" data-mp="desa60m864u">
                <p className="text-sm font-medium text-brand-ink" data-id="element-289" data-mp="cc2y2ixybr1">
                  {volume.listLabel}
                </p>
                <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-290" data-mp="a49gvh1c3htg">
                  {volume.bullets.map(bullet => <li key={bullet} className="rounded-full border border-brand-rose/50 bg-brand-blush px-2.5 py-1 text-xs font-medium text-brand-ink" data-id="element-291" data-mp="3iizv6rsw74fa">
                      {bullet}
                    </li>)}
                </ul>
              </div>
              {volume.flow && <FlowLine className="mt-6" label={volume.flow.label} steps={volume.flow.steps} data-id="element-292" data-mp="17rq90m6v6zy7" />}
              <div className="mt-auto pt-7" data-id="element-293" data-mp="12urhmbel573p">
                <div className="rounded-lg border border-brand-gold/40 bg-brand-goldSoft/60 p-4 text-sm leading-6 text-brand-ink" data-id="element-294" data-mp="38hpf9gmanpsb">
                  <strong className="font-semibold text-brand-deep" data-id="element-295" data-mp="3dgk71828oook">
                    Résultat :{' '}
                  </strong>
                  {volume.result.join(' ')}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}